import roles from "../constants/roles"

// Partner pages are lazy-loaded to keep them out of the initial download.
const DashboardPartner = () => import("../layout/partner/DashboardPartner.vue")
const Properties = () => import("../pages/partner/Properties.vue")
const Users = () => import("../pages/partner/Users")
const Transactions = () => import("../pages/partner/Transactions")
const JualBuProperties = () => import("../pages/partner/JualBuProperties.vue")

const partner = [
  {
    path: "/partner/login",
    component: () => import("../pages/partner/LoginPartner.vue"),
    name: "loginPartner",
    meta: {
      header: "hidden",
      footer: "hidden",
      virtual_balance_bubble: "hidden"
    },
  },
  {
    path: "/partner",
    component: DashboardPartner,
    redirect: "/partner/properties",
    name: "partner",
    meta: {
      authorize: [roles.Partner],
      header: "hidden",
      footer: "hidden",
      virtual_balance_bubble: "hidden"
    },
    children: [
      {
        path: "properties",
        name: "partnerProperties",
        component: Properties
      },
      {
        path: "jual-bu-properties",
        name: "partnerJualBuProperties",
        component: JualBuProperties
      },
      {
        path: "users",
        name: "partnerUsers",
        component: Users
      },
      {
        path: "transactions",
        name: "partnerTransactions",
        component: Transactions
      },
    ]
  }
]

export default partner
